import { Uuid } from "_/types";

export type Image = {
  id: Uuid;
  name: string;
  ownerId: Uuid | null;
  width: number;
  height: number;
  /** RFC 3339 upload time. */
  createdAt: string;
};

/**
 * Retrieves the URL for loading an image.
 */
export function imageURL(id: Uuid): string {
  return `/api/v0/images/${id}/contents`;
}

/**
 * Retrieves the URL for loading an image thumbnail.
 */
export function thumbURL(id: Uuid): string {
  const base = imageURL(id);
  return `${base}?thumbnail=true`;
}

/**
 * Retrieves the URL for loading a video.
 */
export function videoURL(id: Uuid): string {
  return `/api/v0/videos/${id}/contents`;
}

/**
 * Retrieves the URL for loading a video.
 */
export function videoDownloadURL(id: Uuid): string {
  return `/api/v0/videos/${id}`;
}
